import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { Provider } from 'react-redux';
import EventEmitter from 'eventemitter3';
import { validateClientConfig, getAppConfig } from './config';
import * as Utils from './utils';
import * as store from './store/index';
import * as appStore from './store/app';
import Session from './session';
import './lib';
import './polyfills';
import { AUTO_PLAY_BEHAVIOUR, API_KEY_JSON_URlS, APP_EVENTS } from './constants';
import { decryptApiKeyJson } from './utils/encryption';
import PostMessageHandler from './postMessageHandler';
import { checkDomainConfiguration } from './utils';

class CleoClient extends EventEmitter {
  constructor(config = {}, callback = Utils.noop) {
    super();
    const [success, message] = validateClientConfig(config);
    if (!success) {
      callback(message);
      return;
    }
    this.callback = callback;
    this.bootstrap(config);
  }
  async bootstrap(config) {
    this.appConfig = getAppConfig(config);
    this.clientConfig = config;
    // const apiKeyJson1 = await this.fetchApiKeyJson(this.appConfig.apiJsonKey);
    const env = process.env.REACT_APP_API_ENV;

    const apiKeyJson = {
      ver: '1.0.0',
      ctime: 1629953882281,
      mtime: 1629953882281,
      comments: '',
      notes: 'Filling details',
      info: {
        // customerAccount: 'Slike',
        // splApiKey: 'test403web5a8sg6o9ug',
        webSDKVersion: '1.0.0',
        castReceiverId: 'AFA3F964',
        googleclientId: '783768234350-psgstpvr35hfracrh5n0hv2d34iudkvf.apps.googleusercontent.com',
      },
      apis: {
        actPrimary: env === 'dev' ? 'watchstudio.sociofyme.com/stg-actengine' : 'watchstudio.sociofyme.com/actengine', // '10.11.0.139:8081',
        actBackup: env === 'dev' ? 'watchstudio.sociofyme.com/stg-actengine' : 'watchstudio.sociofyme.com/actengine', // '10.11.0.139:8081',
        authEngine: env === 'dev' ? 'watchstudio.sociofyme.com/stg-actengine' : 'watchstudio.sociofyme.com/actengine', // '10.11.0.139:8081',
        actAdmin: env === 'dev' ? 'watchstudio.sociofyme.com/stg-actengine' : 'watchstudio.sociofyme.com/actengine', //'10.11.0.139:8081',
        livesdk: false,
      },
      conf: {
        maxRtc: 0,
        audienceCalling: 0,
        global: {
          domains: ['*.sociofyme.com', '*.timesnownews.com'],
          androidPkgs: [''],
          iosPackages: [''],
        },
        analytics: {
          core: {
            enabled: 0,
            url: '',
            method: 'POST',
          },
          ga: [
            {
              id: 'UA-101719518-2',
              platforms: 'web,ios,android',
              encoding: true,
              encodingfun: 'return md5(id);',
            },
          ],
          firebase: [],
        },
        ui: {
          liveTag: 1,
          liveDuration: 0,
          concurrent: 0,
          controlHideTimeout: 3000,
          hideOnMouseOut: 1,
          alwaysShowTabIcons: 1,
          playerBg: 0,
          theme: '',
          forcefsMobile: true,
          closeTabonClick: true,
        },
        welcomeScreen: {
          changeName: 0,
          showCountdownTimer: 43200000,
        },
        endScreen: {
          showRec: 0,
          showMoments: 1,
        },
        player: {
          autoPlay: 1,
          playPause: 0,
          quality: 1,
          volume: 1,
          chromeCast: 1,
          dvr: 0,
          skipAd: false,
          skipPre: false,
          skipMid: false,
          /*adsData: {
            default: {
              pre: {
                url: [
                  'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_ad_samples&sz=640x480&cust_params=sample_ct%3Dlinear&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=',
                ],
              },
              mid: {
                url: [
                  'https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_preroll_skippable&sz=640x480&ciu_szs=300x250%2C728x90&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=',
                ],
                adFrequency: [60000],
              },
            },
          },*/
          // adsData: {
          //   default: {
          //     pre: {
          //       url: [
          //         'https://pubads.g.doubleclick.net/gampad/ads?iu=/21806551354/TN_English/Desktop/video/TN_English_Desk_VDO_Preroll&description_url=[placeholder]&tfcd=0&npa=0&ad_type=audio_video&sz=1x1%7C400x300%7C420x315%7C480x360%7C480x361%7C640x360%7C640x480&ciu_szs=250x250%2C320x50%2C300x250&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=',
          //       ],
          //     },
          //     mid: {
          //       url: [
          //         'https://pubads.g.doubleclick.net/gampad/ads?iu=/21806551354/TN_English/Desktop/video/TN_English_Desk_VDO_A_Midroll&description_url=[placeholder]&tfcd=0&npa=0&ad_type=audio_video&sz=1x1%7C400x300%7C420x315%7C480x360%7C480x361%7C640x360%7C640x480&ciu_szs=250x250%2C320x50%2C300x250&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=',
          //       ],
          //       adFrequency: [180000],
          //     },
          //   },
          // },
          slikeApiKeyWeb: 'tgbsl486web5ab8uukl9o',
          slikeApiKeyMWeb: 'tgbsl486mweb5ab3ukk6ko',
        },
        previewMode: {
          mode: 1,
          duration: 500000,
          triggerMode: 1,
          triggerUrl: '',
        },
        modules: {
          qna: {
            mode: 1,
            maxCount: 10,
          },
          chat: {
            mode: 1,
            minInputGap: 1000,
            maxLength: 500,
            emoji: 1,
            batchInterval: 2000,
            renderThrottled: 0,
            renderMaxDelay: 500,
            initHistory: 50,
            maxMessages: 200,
            rules: {
              enabled: 1,
              dos: [],
              donts: [],
            },
            quickMessage: {
              enabled: 1,
              messages: [],
            },
            allowedReactions: ['like', 'love', 'wow', 'yay', 'haha'],
          },
          moments: {
            mode: 1,
            saveToCloud: 0,
            cloudApi: '',
            share: [],
            composition: {},
            previewAutoHideTime: 6000,
            maxUploadedFileSize: 5120000,
          },
          react: {
            mode: 1,
            stats: 0,
          },
        },
      },
    };
    this.store = store.configure(this);
    this.store.dispatch(appStore.setAppConfig({ config: this.appConfig, apiKeyJson: apiKeyJson }));
    this.render();
    if (apiKeyJson) {
      var domainAllowed = checkDomainConfiguration(apiKeyJson);
      if (!domainAllowed) {
        this.store.dispatch(appStore.setAppError({ msg: 'Something went wrong', act: 'domain_not_allowed' }));
        return;
      }
      this.loadDependencies(null, (err) => {
        if (err) {
          this.store.dispatch(appStore.setAppError({ msg: 'Something went wrong', act: 'sdk_launch' }));
          this.callback(err);
          return;
        }
        this.checkVideoAutoPlay(config, () => {
          this.postMessageHandler = new PostMessageHandler(this, this.store);
          this.emit(APP_EVENTS.ENV_READY);
          //if rendered in iframe create session will not be invoked directly ,
          // will be called from parent page after setting all required configurations
          // if (!this.postMessageHandler.isRenderedInIframe()) this.createSession();
          // this.createSession();
          if (!this.postMessageHandler.isRenderedInIframe() || !this.clientConfig.sdk) this.createSession();
        });
      });
    } else {
      this.store.dispatch(appStore.setAppError({ msg: 'Something went wrong', act: 'sdk_launch' }));
    }
  }

  createSession() {
    this.session = new Session(this, this.store);
    this.session.handleUserAuth();
    this.callback();
  }

  async fetchApiKeyJson(apiKey, cb) {
    var fetchResponse;
    let env = process.env.REACT_APP_API_ENV ? `${process.env.REACT_APP_API_ENV}/` : '';
    if (env === 'prod/') env = '';
    var i = 0;
    for (i = 0; i < API_KEY_JSON_URlS.length; i++) {
      const url = `${API_KEY_JSON_URlS[i]}/c/apikey/${apiKey}/${env}web.json`;
      try {
        fetchResponse = await fetch(url);
        if (fetchResponse) {
          break;
        }
      } catch (e) {
        console.error('fetchApiKeyJson error', e);
      }
    }
    if (fetchResponse) {
      const textResponse = await fetchResponse.arrayBuffer();
      const imageUrl = `${API_KEY_JSON_URlS[i]}/c/apikey/${apiKey}/${env}logo.png`;
      const decryptedResponse = await decryptApiKeyJson(new Uint8Array(textResponse), imageUrl);
      if (decryptedResponse) {
        return decryptedResponse;
      }
      return null;
    }
    return null;
  }

  async checkVideoAutoPlay(config, callback) {
    if (this.appConfig.castMode || this.appConfig.puppet) {
      this.store.dispatch(appStore.setAutoPlayBehavior(AUTO_PLAY_BEHAVIOUR.ALLOW));
      callback();
      return;
    }
    const autoPlay = this.store.getState().app.apiJsonConfig.autoPlay;

    if (autoPlay === AUTO_PLAY_BEHAVIOUR.NEVER) {
      this.store.dispatch(appStore.setAutoPlayBehavior(AUTO_PLAY_BEHAVIOUR.NEVER));
      callback();
      return;
    }
    let autoPlayResult = await Utils.checkAutoPlay({ muted: false });
    if (autoPlayResult) {
      if (autoPlay === AUTO_PLAY_BEHAVIOUR.WITHOUT_SOUND) {
        console.log('Auto Play Allowed,Forcing with mute');
        this.store.dispatch(appStore.setAutoPlayBehavior(AUTO_PLAY_BEHAVIOUR.WITHOUT_SOUND));
        callback();
        return;
      }
      console.log('Auto Play Allowed');
      this.store.dispatch(appStore.setAutoPlayBehavior(AUTO_PLAY_BEHAVIOUR.ALLOW));
    } else if (autoPlay === AUTO_PLAY_BEHAVIOUR.WITHOUT_SOUND || autoPlay === AUTO_PLAY_BEHAVIOUR.ALLOW) {
      autoPlayResult = await Utils.checkAutoPlay({ muted: true });
      if (autoPlayResult) {
        console.log('Auto Play Allowed With Mute');
        this.store.dispatch(appStore.setAutoPlayBehavior(AUTO_PLAY_BEHAVIOUR.WITHOUT_SOUND));
      }
    }
    if (!autoPlayResult) {
      console.log('Auto play not allowed');
    }
    callback();
  }

  async loadDependencies(dependencies, callback = Utils.noop) {
    if (!dependencies) {
      dependencies = ['sw'];
      dependencies.push('livesdk');
      if (this.appConfig.comments) {
        dependencies.push('chat');
      }
      if (this.appConfig.screenshot) {
        dependencies.push('screenshot');
      }
      if (this.appConfig.castMode) {
        dependencies = ['sw'];
      }
    }
    dependencies = dependencies.map((dep) => `REACT_APP_${dep.toUpperCase()}_PATH`);
    const livesdk = this.store.getState().app.apiKeyJson?.apis?.livesdk;
    const dependencyLoadPromises = dependencies.map((dep) => {
      if (dep === 'REACT_APP_LIVESDK_PATH' && !livesdk) {
        dep = 'REACT_APP_LIGHTLIVESDK_PATH';
      }
      if (dep === 'REACT_APP_SW_PATH') {
        const url = `${window.location.protocol}//${window.location.hostname}${
          window.location.port ? ':' + window.location.port : ''
        }/${process.env[dep]}?v=${process.env.VERSION}`;

        return Utils.loadJs(url);
      }

      return Utils.loadJs(`${process.env[dep]}?v=${process.env.REACT_APP_VERSION}`);
    });
    try {
      await Promise.all(dependencyLoadPromises);
    } catch (err) {
      callback('Failed to load dependencies');
      return;
    }
    callback();
  }

  render() {
    ReactDOM.render(
      <Provider store={this.store}>
        <App ctrl={this} />
      </Provider>,
      document.getElementById(this.appConfig.contEl),
    );
  }
  static get commitHash() {
    return process.env.COMMIT_HASH;
  }
}

window.CleoClient = CleoClient;
